import type { Game, GameKind } from '@talkvibe/shared';

import { api } from './api.ts';

/**
 * Games, over HTTP.
 *
 * Every one of these returns the whole game rather than an acknowledgement, so
 * the caller never has to work out what the board became — the server has
 * already decided, and this is what it decided. That is also what makes the
 * socket frame and the HTTP reply the same shape: whichever arrives first, the
 * store applies it the same way.
 */
export const gameService = {
  /** Starts a game, or returns the one already being played in that conversation. */
  start: (conversationId: string, kind: GameKind = 'tictactoe'): Promise<Game> =>
    api.post<Game>('/api/games', { conversationId, kind }),

  /** The game in progress, or null. */
  active: (conversationId: string): Promise<Game | null> =>
    api.get<Game | null>(`/api/conversations/${conversationId}/game`),

  byId: (gameId: string): Promise<Game> => api.get<Game>(`/api/games/${gameId}`),

  /** Takes a square. The server decides whether it was allowed. */
  move: (gameId: string, cell: number): Promise<Game> =>
    api.post<Game>(`/api/games/${gameId}/move`, { cell }),

  resign: (gameId: string): Promise<Game> => api.post<Game>(`/api/games/${gameId}/resign`),
};
